var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc271a",
    d: "M30 22.15V24H0v-1.85zm0-3.69v1.85H0v-1.85zm0-3.7v1.85H0v-1.84zm0-3.68v1.84H0v-1.84zm0-3.7v1.85H0V7.38zm0-3.69v1.85H0V3.69zM30 0v1.86H0V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010062",
    d: "M0 0h4v.02h11V14.8H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6cd46",
    d: "m10.64 4.1.3 2 1.12-1.67-.6 1.93 1.74-1.02-1.38 1.48 2.01-.17-1.88.73 1.88.73-2.01-.16 1.38 1.48-1.74-1.02.6 1.93-1.13-1.68-.3 2-.28-2-1.13 1.68.6-1.93-1.74 1.02 1.38-1.48-2.02.16 1.89-.73-1.89-.73 2.02.17-1.38-1.48 1.74 1.02-.6-1.93 1.13 1.68z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6cd46",
    d: "M9 4.19a3.5 3.5 0 1 0 0 6.39 3.93 3.93 0 1 1 0-6.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.663d91e789c55af76b81232c7652a862.svg";
export { ForwardRef as ReactComponent };